// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3fyb-","header":"PatientBlock_header__2VVVb","label":"PatientBlock_label__1beJW","option":"PatientBlock_option__10T-l"};